import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { EmptyRecRepFilter, Filter, IRevenueRepFilter } from "../Filter";
import { Fetch, ILazyParams } from "../../../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { ProjectRevenueDetails } from "./ProjectRevenueDetails";
import { Rating } from "./Rating";
import { ILogin } from "../../../../models/Login";

interface IProps {
    toast: any
}

interface IRevenueList {
    branch_ID?: number,
    branchName?: string,
    company_Name?: string,
    noOfECI?: number,
    noOfPO?: number,
    branch_Monthly_CTC?: number,
    branch_Seating_Cost?: number,
    incentive?: number,
    revenues?: number,
    rev_P_L?: number,
    projected_Revenues?: number,
    projected_Incentive?: number,
    projected_Salary?: number,
    projected_Rev_P_L?: number,
    projected_Seating_Cost?: number,
}

export const Table = (props: IProps) => {
    const [totalRecords, setTotalRecords] = useState(0);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IRevenueList>, loading: boolean });
    const [revenueFilter, setRevenueFilter] = useState<IRevenueRepFilter>(EmptyRecRepFilter);
    const [openProjectRevenueDetails, setOpenProjectRevenueDetails] = useState({ open: false, branchID: 0 } as { open: boolean, branchID: number });

    const dt = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    loginObj.roles.forEach((role) => {
        _roles.push(role.role_ID);
    });

    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'login_ID',
        sortOrder: -1
    });

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const header = () => <p>Revenue Report</p>;

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        // const response = await Fetch("Report_Revenue", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(revenueFilter)}`, props.toast);
        const response = await Fetch("Report_Revenue/getBranchRevenueReport", "GET", null, `filter=${JSON.stringify(revenueFilter)}`, props.toast);
        if (response) {
            const data: Array<IRevenueList> = await response.json();
            // if (data.length > 0) setTotalRecords(0);
            // else 
            setTotalRecords(0);
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const projectRevenue = (rowData: IRevenueList) => {
        return <p onClick={() => {
            if (rowData.projected_Revenues && rowData.projected_Revenues > 0) {
                setOpenProjectRevenueDetails({ open: true, branchID: (rowData.branch_ID || 0) });
            } else props.toast.current.show({ severity: 'info', detail: 'No Projected Revenue Details To Show', life: 3000 });
        }} className="cursor-pointer text-cyan-700 underline">₹ {parseInt(`${rowData.projected_Revenues}`)}</p>;
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const leftToolbarTemplate = () => {
        return (
            <>
                <div className="my-2">
                    <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => loadTableData()} />
                </div>
            </>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                {(_roles.includes(1) || _roles.includes(12)) && <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />}
            </>
        );
    }

    useEffect(() => {
        loadTableData();
    }, [lazyParams, revenueFilter]);

    // ₹

    return (
        <>
            <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate} className="mb-3" />
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter revenueFilter={revenueFilter} setRevenueFilter={setRevenueFilter} showNormalUsers={false} showRecHeadUsers={false} showSalesHeadUsers={false} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                lazy dataKey="branch_ID" responsiveLayout="scroll"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Users found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="branchName" header="Branch" />
                <Column field="company_Name" header="Company" />
                <Column field="noOfECI" header="ECI" />
                <Column field="noOfPO" header="PO" />
                <Column field="branch_Monthly_CTC" header="Branch Monthly CTC" body={(rowData: IRevenueList) => <p>₹ {parseInt(`${rowData.branch_Monthly_CTC}`)}</p>} />
                <Column field="branch_Seating_Cost" header="Branch Seating Cost" body={(rowData: IRevenueList) => <p>₹ {parseInt(`${rowData.branch_Seating_Cost}`)}</p>} />
                <Column field="incentive" header="Incentive" body={(rowData: IRevenueList) => <p>₹ {parseInt(`${rowData.incentive}`)}</p>} />
                <Column field="revenues" header="Revenue" body={(rowData: IRevenueList) => <p>₹ {parseInt(`${rowData.revenues}`)}</p>} />
                <Column field="rev_P_L" header="Revenue Profit/Loss" body={(rowData: IRevenueList) => <p style={{ color: ((rowData.rev_P_L || 0) >= 0) ? "green" : "red" }} >₹ {parseInt(`${(rowData.rev_P_L || 0) > 0 ? (rowData.rev_P_L || 0) : (-1 * (rowData.rev_P_L || 0))}`)}</p>} />
                {/* <Column field="projected_Revenues" header="Projected Revenue" body={(rowData: IRevenueList) => <p>₹ {parseInt(`${rowData.projected_Revenues}`)}</p>} /> */}
                <Column field="projected_Revenues" header="Projected Revenue" body={projectRevenue} />
                <Column field="projected_Incentive" header="Projected Incentive" body={(rowData: IRevenueList) => <p>₹ {parseInt(`${rowData.projected_Incentive}`)}</p>} />
                <Column field="projected_Salary" header="Projected Branch Salary" body={(rowData: IRevenueList) => <p>₹ {parseInt(`${rowData.projected_Salary}`)}</p>} />
                <Column field="projected_Seating_Cost" header="Projected Seating Cost" body={(rowData: IRevenueList) => <p>₹ {parseInt(`${rowData.projected_Seating_Cost}`)}</p>} />
                <Column field="projected_Rev_P_L" header="Projected Revenue Profit/Loss" body={(rowData: IRevenueList) => <p style={{ color: ((rowData.projected_Rev_P_L || 0) >= 0) ? "green" : "red" }} >₹ {parseInt(`${(rowData.projected_Rev_P_L || 0) > 0 ? (rowData.projected_Rev_P_L || 0) : (-1 * (rowData.projected_Rev_P_L || 0))}`)}</p>} />
                {/* <Column field="" header="P.R P/L" body={projectRevenuePL} /> */}
                <Column field="" header="Action" />
                <Column field="rating" header="Rating" headerStyle={{ minWidth: "12rem" }} bodyStyle={{ minWidth: "12rem" }} body={(rowData: IRevenueList) => <Rating rev={(rowData.revenues || 0)} exp={((rowData.branch_Monthly_CTC || 0) + (rowData.incentive || 0) + (rowData.branch_Seating_Cost || 0))} />} />
            </DataTable>
            <ProjectRevenueDetails open={openProjectRevenueDetails.open} hideDialog={() => setOpenProjectRevenueDetails({ open: false, branchID: 0 })} branchID={openProjectRevenueDetails.branchID} revenueFilter={revenueFilter} toast={props.toast} />
        </>
    );
}